import type { ActionTree, ActionContext } from 'vuex'
import type { ModelMetadata } from '@/types/devices'
import type { RootState } from '@/store'
import type { DeviceModelsState } from './types'
import { DEVICE_MODELS_MUTATIONS, DEVICE_MODELS_ACTIONS } from './types'

interface IDeviceModelsActions extends ActionTree<DeviceModelsState, RootState> {
  [DEVICE_MODELS_ACTIONS.SET_MODELS_META_DATA](
    context: ActionContext<DeviceModelsState, RootState>,
    data: ModelMetadata
  ): void
}

const actions: IDeviceModelsActions = {
  [DEVICE_MODELS_ACTIONS.SET_MODELS_META_DATA]({ commit }, data) {
    commit(DEVICE_MODELS_MUTATIONS.SET_MODELS_META_DATA, data)
  }
}

export default actions
